import { CommonRuntime } from "utils/runtime";

export interface JudgeAppVersionParams {
  runtime: CommonRuntime;
  iosVersion?: number;
  androidVersion?: number;
}

export function judgeAppVersion(params: JudgeAppVersionParams) {
  const { runtime, iosVersion, androidVersion } = params;
  const { isInApp, cookies, client } = runtime;
  const appVersion = cookies?.["versionCode"];
  if (isInApp && appVersion && !Number.isNaN(+appVersion)) {
    console.log("appVersion", appVersion);
    const newAppVersion =
      client === "ios" && iosVersion
        ? iosVersion
        : androidVersion
        ? androidVersion
        : null;
    // 如果没有传需要控制的版本，统一返回true，都支持
    return newAppVersion ? !(+appVersion < newAppVersion) : true;
  }
  return false;
}
